import { connect } from "react-redux";

import { actions as modelActions } from "features/Model/_ducks";
import { actions as enclosureActions } from "features/Model/Enclosure/_ducks";
import { actions as userActions } from "store/users";
import { actions as organizationActions } from "store/organizations";
import { actions as resultsActions } from "features/Model/Review/Results/_ducks";
import { actions as upgradeActions } from "features/Model/Upgrades/_ducks";
import { clearDrawingData } from "features/Model/DrawingNew/_ducks/actions";

import { createFolder, deleteFolder, renameFolder, moveFolder, batchFolderRemove } from "store/folders/thunk";
import { fetchDrawingData } from "features/Model/DrawingNew/_ducks/thunk";

import Dashboard from "./";
import { requestVoltaSnapOrganization } from "utils/fileSharing/api";

const {
    clearModelData,
    fetchModelData,
    modelLoading,
    setExportErrors,
    deleteModel,
    moveModel,
    duplicateModel,
    batchDeleteModels,
    removeModelFromDashboard,
} = modelActions;

const { fetchUserDir, removeFromDir, saveUserMeta } = userActions;
const { fetchUserOrganization, fetchOrgDir } = organizationActions;

const { clearEnclosureState } = enclosureActions;
const { resetResults } = resultsActions;
const { clearUpgradeData } = upgradeActions;

const mapStateToProps = ({
    user: {
        uid,
        name = "",
        email = "",
        modelDir = {},
        error,
        modelDirLoading = false,
        userMeta: { organizationRequested = false, company = "", role = "", agreedToTerms = false } = {},
    },
    organization = {},
    folder: { isLoading },
    model: { loading },
}) => ({
    uid,
    name,
    email,
    modelDir,
    error,
    modelDirLoading,
    folderLoading: isLoading || modelDirLoading,
    modelLoading: loading,
    organization,
    organizationRequested,
    company,
    role,
    agreedToTerms,
    requestVoltaSnapOrganization,
});

const mapDispatchToProps = (dispatch, { history }) => ({
    fetchUserDir: (uid, skipLoading) => dispatch(fetchUserDir(uid, skipLoading)),
    fetchUserOrganization: (uid, orgId) => dispatch(fetchUserOrganization(uid, orgId)),
    fetchOrgDir: (orgId, skipLoading) => dispatch(fetchOrgDir(orgId, skipLoading)),
    clearModelData: () => dispatch(clearModelData()),
    selectModel: async (modelId) => {
        await Promise.all([
            dispatch(clearModelData()),
            dispatch(clearDrawingData()),
            dispatch(resetResults()),
            dispatch(clearUpgradeData()),
            dispatch(clearEnclosureState()),
            dispatch(setExportErrors([])),
            dispatch(modelLoading()),
            dispatch(fetchModelData(modelId)),
            dispatch(fetchDrawingData(modelId)),
        ]).then(() => history.push(`/models/${modelId}`));
    },
    deleteModel: async ({ modelId, uid }) => {
        await dispatch(deleteModel({ modelId, uid }));
        return dispatch(removeFromDir(modelId));
    },
    removeSharedModelFromDir: async ({ modelId, uid }) => {
        await dispatch(removeModelFromDashboard({ modelId, uid }));
        return dispatch(removeFromDir(modelId));
    },
    // orgId routes write to the organization's shared tree instead of the user's own
    createFolder: async (uid, newFolderName, parentFolderId, orgId) =>
        dispatch(createFolder(uid, newFolderName, parentFolderId, "modelDir", orgId)),
    deleteFolder: async (folderId, uid, orgId) => dispatch(deleteFolder(folderId, uid, "modelDir", orgId)),
    renameFolder: async (folderId, uid, newFolderName, orgId) =>
        dispatch(renameFolder(folderId, uid, newFolderName, "modelDir", orgId)),
    moveFolder: async (folderId, uid, moveToId, skipLoading, orgId) =>
        dispatch(moveFolder(folderId, uid, moveToId, skipLoading, "modelDir", orgId)),
    moveModel: async (modelId, uid, folderId, skipLoading, orgId) =>
        dispatch(moveModel(modelId, uid, folderId, skipLoading, orgId)),
    duplicateModel: async (modelId, uid, folderId, duplicateName) =>
        dispatch(duplicateModel(modelId, uid, folderId, duplicateName)),
    batchFolderRemove: async (foldersToDelete, uid, orgId) =>
        dispatch(batchFolderRemove(foldersToDelete, uid, "modelDir", orgId)),
    batchDeleteModels: async (modelsToDeleteIds, uid) => dispatch(batchDeleteModels(modelsToDeleteIds, uid)),
    saveUserMeta: ({ uid, userMeta }) => dispatch(saveUserMeta({ uid, userMeta })),
});

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
